<template>
  <section id="bto-info-panel">
    <div id="bto_info_panel_design_view">
      <h2>デザイン(配置)</h2>
      <img :src="url" alt="デザインイメージ画像" />
      <h3 id="bto_info_panel_design_name">{{ designName }}</h3>
    </div>

    <div id="bto-info-panel-chart">
      <h2>運勢チャート</h2>
      <slot name="accessory-info-chart"></slot>
    </div>

    <div id="bto-info-panel-parts-list">
      <h2>使用パワーストーン</h2>
      <slot name="accessory-info-parts-list"></slot>
    </div>
  </section>
</template>

<script>
export default {
  name: "PanelAccessoryInfo",

  props: {
    imgurl: {
      type: String,
    },
    designName: {
      type: String,
    },
  },

  computed: {
    url() {
      return this.imgurl;
    },
  },
};
</script>

<style scoped lang="stylus">

#bto-info-panel
  width: auto

#bto_info_panel_design_view,
#bto-info-panel-parts-list,
#bto-info-panel-chart
  overflow: visible
  margin-top: 15px
  background-color: #efebe3;
  h2
    background-image: url($css-assets bg_h2_bto_left.png)
    background-repeat: no-repeat
    width: 190px
    height: 56px
    overflow: hidden
    white-space: nowrap
    text-indent: 190px
    position: relative
    top: -15px

#bto-info-panel-parts-list
  h2
    background-position: 0 -112px

#bto-info-panel-chart
  h2
    background-position: 0 -56px
  canvas
    max-height: 162px


@screen lg
  #bto-info-panel
    min-width: 190px

@css {
  #bto-info-panel {
    @apply text-left text-xs
  }

  #bto_info_panel_design_view {
    @apply text-center pb-4
  }
  #bto_info_panel_design_view img {
    @apply bg-white my-2 mx-auto
  }
  #bto-info-panel-parts-list {
    @apply pb-4
  }
  #bto-info-panel-chart {
    @apply p-0 pb-4
  }
}
</style>
